import { render, staticRenderFns } from "./OrderServe.vue?vue&type=template&id=0f5951aa&scoped=true"
import script from "./OrderServe.vue?vue&type=script&lang=js"
export * from "./OrderServe.vue?vue&type=script&lang=js"
import style0 from "./OrderServe.vue?vue&type=style&index=0&id=0f5951aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5951aa",
  null
  
)

export default component.exports